import React from 'react';
import MerchantRedemptionCard from './components/MerchantRedemptionIndex.jsx';

const MerchantRedemption = () => <MerchantRedemptionCard />;

export default MerchantRedemption;
